import { useMemo } from "react";
import { sortBy, sortByCustom } from "@repo/utils";
import { SortBy, type SortType, type StatusGroup } from "../task.types";

export const useTaskSorting = (items: StatusGroup[], sortType?: SortType) => {
  return useMemo(() => {
    switch (sortType) {
      case SortBy.Name:
        return sortBy(items, "name", "asc");
      case SortBy.Workflow:
        return items.map((group) => ({
          ...group,
          children: sortByCustom(group.children, (child) => child.workflowId ?? 0, "asc"),
        }));
      default:
        return items;
    }
  }, [items, sortType]);
};
